// Vue
import Vue from 'vue';

// polyfills
import 'es6-promise/auto'
import "formdata-polyfill";
import 'url-search-params-polyfill' // used in ajax requests
import addBlurToSvg from './lib/addBlurEventToSvg.js' // fix IE11 bug
addBlurToSvg();

// adds class to body so we can enable/disable focus rings
// https://github.com/ten1seven/what-input
import 'what-input';

// lazy image loading
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import lazySizes from 'lazysizes';

// Vue Swiper
// https://github.com/surmon-china/vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// Vue Modal
// https://github.com/euvl/vue-js-modal
import VModal from 'vue-js-modal'
Vue.use(VModal)

// Vue Cookie
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

// Vee validate form validation
// https://github.com/baianat/vee-validate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// components
import Alert from './components/Alert.vue';
import MainMenu from './components/MainMenu.vue';
import WineClubOverview from './components/WineClubOverview.vue';
import Gallery from './components/Gallery.vue';
import VimeoEmbed from './components/VimeoEmbed.vue';
import AddressFieldset from "./components/shop/AddressFieldset.vue";
import AddToCart from "./components/shop/AddToCart.vue";
import Cart from "./components/shop/Cart.vue";
import QtyForm from "./components/shop/QtyForm.vue";
import DiscountCode from "./components/shop/DiscountCode.vue";
import AddressForm from "./components/shop/AddressForm.vue";
import ClubSelect from "./components/shop/ClubSelect.vue";
import CheckoutAddresses from "./components/shop/CheckoutAddresses.vue";
import Accordian from "./components/Accordian.vue";
import Tabs from "./components/Tabs.vue";
import EventTicket from "./components/EventTicket.vue";
import ClubShipment from "./components/ClubShipment.vue";
import ClubSignup from "./components/ClubSignup.vue";
import MailingListForm from "./components/MailingListForm.vue";

new Vue({
  el: '#app',

  delimiters: ['${', '}'],

  csrf: {
    name: window.csrfTokenName,
    value: window.csrfTokenValue
  },

  components: {
    Alert,
    MainMenu,
    WineClubOverview,
    Gallery,
    VimeoEmbed,
    AddressFieldset,
    AddToCart,
    Cart,
    QtyForm,
    DiscountCode,
    AddressForm,
    Accordian,
    Tabs,
    EventTicket,
    ClubShipment,
    ClubSignup,
    ClubSelect,
    CheckoutAddresses,
    MailingListForm
  }
})



// WEBPACK FOOTER //
// ./_js/main.js